import React from 'react';
import { Box, Typography } from '@mui/joy';
//import { authFetch } from '../utils/authFetch';

export default function Dashboard() {

  return (

        <Box>
          <Typography level="h3" mb={2}>
            Benvenuto nella Dashboard
          </Typography>
          <Typography>
            Qui puoi gestire utenti, mezzi e checklist. ✨
          </Typography>
        </Box>
  );
}
